/*
    text-updated

    Listeners:
        - src/components/page/report/index.vue
        - src/components/page/report/editableZone.vue
    Emiters:
        - src/components/page/report/pdfDescriptorInput.vue
*/


import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./src/eventBus.js